export const environment = {
  envName: 'production',
  production: true,
  enableSEO: true,
  sentryLogging: true,
  apiUrl: typeof window === 'undefined' ? 'http://klubovna-api-prod:3000/api' : 'https://klubovnasl.sk/api',
  appUrl: 'https://klubovnasl.sk',
  consoleUrl: 'https://app.klubovnasl.sk',
  staticContentUrl: 'https://s3.klubovnasl.sk/klubovna-public',
};
